import React from 'react'
import classNames from 'classnames'
import { makeStyles } from '@material-ui/core'
import { ToggleButton } from './toggle-button'
import { Checkbox } from '..'
import { Highlighted } from '../highlighted'

const useStyles = makeStyles(theme => ({
    name: {
        flex: 1,
        minWidth: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    row: {
        // cursor: 'pointer',
        height: '100%',
        // margin: "0 12px",
        flex: 1,
        overflow: 'hidden',
        border: '2px solid transparent',
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'center'
    },
    locationsTreeLabelSelected: {
        fontWeight: 'bold',
        backgroundColor: theme.primary,
        color: theme.textPrimaryReverted,
        '& > div > div': {
            fontWeight: 'bold'
        }
    },
    checkbox: {
        marginLeft: 'auto'
    }
}))

export function TreeNode({
    node,
    style,
    onSelect,
    isSelected,
    indeterminate,
    icon,
    onPress,
    isUserMgmt,
    locationSearchStr
}) {
    const classes = useStyles()
    const data = node.data
    const hasChildren = node.isInternal
    const open = node.isOpen
    const name = data.location.name
    const rowSelected = isUserMgmt ? isSelected : node.isSelected

    const handleClick = e => {
        e.stopPropagation()

        if (isUserMgmt) {
            if (onSelect) {
                onSelect(!isSelected, data.location)
            }
        } else {
            node.handleClick(e)
            onPress?.(data.id)
        }
    }

    const handleToggle = event => {
        event.stopPropagation()
        node.toggle()
    }

    return (
        <div style={{ height: '100%', width: '100%' }} onClick={handleClick}>
            <div
                style={style}
                className={classNames(classes.row, {
                    [classes.locationsTreeLabelSelected]: node.isSelected
                })}>
                <ToggleButton
                    toggle={handleToggle}
                    isOpen={open}
                    hasChildren={hasChildren}
                    isSelected={rowSelected}
                />
                <span className={classes.name}>
                    <Highlighted text={name} highlight={locationSearchStr} />
                </span>
                {icon ? icon : null}
                {onSelect ? (
                    <Checkbox
                        disableRipple
                        className={classes.checkbox}
                        customOnClick={e => e.stopPropagation()}
                        onClick={(_, checked) =>
                            onSelect(checked, data.location)
                        }
                        checked={isSelected}
                        indeterminate={indeterminate}
                    />
                ) : null}
            </div>
        </div>
    )
}
